<template>
    <div class="ma-auto" style="width: 100%;" v-for="option in options" :key="option.id">
        <div class="text-subtitle-2 text-md-h6" style="width: 100%; color: grey">{{  option.name }}</div>
        <v-divider class="mb-2" style="width: 100%"/>
        <v-row no-gutters class="mt-1">
            <options-images :type="type" :elements="option.elements" @modelLoaded="$emit('modelLoaded', $event)" />
        </v-row>
    </div>
</template>
<script>
    import OptionsImages from './OptionsImages.vue'
    export default {
        name: 'ListOptions',
        components: {
            OptionsImages,
        },

        props: {
            options: Array,
            type: String
        },

        emits: ["modelLoaded"],

        computed: {
            getClass () {
                if(this.type === 'model') return 'text-susbtitle-1 text-md-h6 font-weight-bold'
                else if (this.type === 'shade') return 'text-subtitle-1 font-weight-bold'
                return ''
            }
        }
    }
</script>
